import React from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as Book } from '../../../../webcommon/common/Icons/Book.svg';
import { noop } from 'lodash';
import styles from './TradePricedFooter.module.scss';

const ProcessSelectedTrades = props => (
    <button
        className={ styles.footerButton }
        type="button"
        onClick={ props.processSelectedTrades }
    >
        {props.process} Included Trades <Book />
    </button>
);

ProcessSelectedTrades.propTypes = {
    process: PropTypes.string,
    processSelectedTrades: PropTypes.func
};

ProcessSelectedTrades.defaultProps = {
    process: '',
    processSelectedTrades: noop
};

export default ProcessSelectedTrades;
